import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import CategoriesSecurityEquipment from "../features/Products/CategoriesSecurityEquipment";
import ProductsListContainer from "../features/Products/ProductsListContainer";
import LoginPage from "../features/User/LoginPage";
import AskResetPasswordPage from "../features/User/ChangePassword/AskResetPasswordPage";
import ProductItemDetail from "../features/Products/ProductDetail/ProductItemDetail";
import CreateAccountPage from "../features/User/Account/CreateAccountPage";
import ProfilePage from "../features/User/Account/ProfilePage";
import ContactFormContainer from "../features/Contact/ContactFormContainer";
import CartPageContainer from "../features/Cart/CartPageContainer";
import OfferRequestPage from "../features/Offer/OfferRequestPage";
import SearchResultsPage from "../features/Search/SearchResultsPage";

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:locale/login" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />

                <Route path="/:locale/mot-de-passe-oublie" element={<AskResetPasswordPage />} />
                <Route path="/:locale/watchwoord-vergeten" element={<AskResetPasswordPage />} />
                <Route path="/:locale/reset-mot-de-passe" element={<AskResetPasswordPage />} />
                <Route path="/:locale/reset-watchwoord" element={<AskResetPasswordPage />} />
                <Route path="/mot-de-passe-oublie" element={<AskResetPasswordPage />} />
                <Route path="/watchwoord-vergeten" element={<AskResetPasswordPage />} />
                <Route path="/reset-mot-de-passe" element={<AskResetPasswordPage />} />
                <Route path="/reset-watchwoord" element={<AskResetPasswordPage />} />

                <Route path="/" element={<CategoriesSecurityEquipment />} />
                <Route path="/:locale" element={<CategoriesSecurityEquipment />} />

                <Route path="/:locale/produits" element={<ProductsListContainer />} />
                <Route path="/:locale/producten" element={<ProductsListContainer />} />

                <Route path="/:locale/produit/*" element={<ProductItemDetail />} />
                <Route path="/:locale/product/*" element={<ProductItemDetail />} />

                <Route path="/:locale/creer-compte" element={<CreateAccountPage />} />
                <Route path="/:locale/account-aanmaken" element={<CreateAccountPage />} />

                <Route path="/:locale/profil" element={<ProfilePage />} />
                <Route path="/:locale/profiel" element={<ProfilePage />} />

                <Route path="/:locale/contact" element={<ContactFormContainer />} />

                <Route path="/:locale/panier" element={<CartPageContainer />} />
                <Route path="/:locale/mandje" element={<CartPageContainer />} />

                <Route path="/:locale/demander-offre" element={<OfferRequestPage />} />
                <Route path="/:locale/verzoek-voorstel" element={<OfferRequestPage />} />

                <Route path="/:locale/search/node" element={<SearchResultsPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
